"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Icon } from "./Icon";
import { JsonLd } from "./JsonLd";
import { faqSchema, type FaqItem } from "@/lib/schema";

type Props = {
  items: FaqItem[];
  eyebrow?: string;
  heading: string;
  intro?: string;
  openFirst?: boolean;
};

export function Faq({ items, eyebrow, heading, intro, openFirst = true }: Props) {
  const [openIndex, setOpenIndex] = useState<number | null>(openFirst ? 0 : null);

  return (
    <section className="section faq-section" data-screen-label="FAQ">
      <div className="container">
        <div className="section-head reveal">
          {eyebrow && (
            <span className="eyebrow">
              <span className="dot" /> {eyebrow}
            </span>
          )}
          <h2>{heading}</h2>
          {intro && <p>{intro}</p>}
        </div>
        <div className="faq-list" data-reveal-group>
          {items.map((it, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={it.q}
                className={`faq ${isOpen ? "is-open" : ""}`}
                onClick={() => setOpenIndex(isOpen ? null : i)}
              >
                <div className="faq__head">
                  <span className="faq__q">{it.q}</span>
                  <span className="faq__icon" aria-hidden="true">
                    <Icon name="plus" />
                  </span>
                </div>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ type: "spring", stiffness: 300, damping: 30 }}
                      className="faq__body-wrap"
                    >
                      <div className="faq__body">
                        <p>{it.a}</p>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
      <JsonLd data={faqSchema(items)} />
    </section>
  );
}
